<template>
    <div>
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/arr_02.png" alt=""> {{data.department_name}}
            <span class="tt">计费项明细</span>
        </header>
        <div class="timeBox">
            <div class="tt">
                <img src="../../assets/jxwx/line.png" alt="">本月明细
            </div>
        </div>
        <div class="chargeList f-bcf">
            <div class="tt">本月累计</div>
            <div class="totalNum ">{{data.totalFee | moneyP}}</div>
            <ul class="box">
                <li>
                    <div class="lf">绩效项</div>
                    <div class="rg">本月累计</div>
                </li>
                <li>
                    <div class="lf">诊查费</div>
                    <div class="rg">{{data.examinationFee | moneyP}}</div>
                </li>
                <li>
                    <div class="lf">收住院</div>
                    <div class="rg">{{data.inpatientNumFee | moneyP}}</div>
                </li>
                <li>
                    <div class="lf">检查开单</div>
                    <div class="rg">{{data.checkorderFee | moneyP}}</div>
                </li>
                <li>
                    <div class="lf">手术费</div>
                    <div class="rg">{{data.operationFee | moneyP}}</div>
                </li>
                <li>
                    <div class="lf">检查相关</div>
                    <div class="rg">{{data.checkrelatedFee | moneyP}}</div>
                </li>
                <li>
                    <div class="lf">单项统计</div>
                    <div class="rg">{{data.singleFee | moneyP}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            data:this.$route.query.data
        };
    },
    mounted() {},
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        }
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 0 0 3.3vw;
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .tt {
        margin-left: 4vw;
    }
}
.timeBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 10.6vw;
    padding: 0 4vw;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    background-color: #fff;
    font-size: 16px;
    img {
        width: 1vw;
        margin-right: 3.2vw;
    }
    .time {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #a6a6a6;
        img {
            width: 2.4vw;
            margin-left: 2vw;
            margin-right: 0;
        }
    }
}
.chargeList {
    padding-top: 4.6vw;
    .tt {
        margin: 0 0 1.6vw 0;
        font-size: 13px;
        color: #a6a6a6;
        text-align: center;
    }
    .totalNum {
        font-size: 28px;
        color: #e5323b;
        text-align: center;
    }
    .box {
        padding: 6vw 4vw;
        li{
            display: flex;
            justify-content: space-between;
            padding: 4vw 0;
            border-bottom:1px solid #dedede;
            .rg{
                width: 30vw;
                text-align: center;
            }
        }
        li:first-child{
            margin: 0 -4vw;
            padding: 4vw;
            background-color: #fafcff;
            color: #a6a6a6;
            border-top:1px solid #dedede;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/itemDetail.vue